import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import AnswerChart from './AnswerChart';
import AnswerDescriptionBox from './AnswerDescriptionBox';
import SampleHeader from './SampleHeader';
import { DetailedSectionEvaluation } from '../../../redux/types';

type Props = {
  section: DetailedSectionEvaluation;
  sectionJustification?: string;
  excludedQuestionSection?: string[];
}

const SectionEvaluation: React.FC<Props> = ({
  section,
  sectionJustification,
  excludedQuestionSection,
}: Props) => (
  <div>
    {
        Object.keys(section.questions).map((questionKey) => (
          (excludedQuestionSection === undefined
          || (excludedQuestionSection
          && excludedQuestionSection.indexOf(questionKey) === -1))
          && (
          <div
            key={questionKey}
            className="mb4"
          >
            <Typography variant="h6">{section.questions[questionKey].translatable.text}</Typography>
            <SampleHeader numSamples={section.questions[questionKey].answersBySamples.length} />
            <Box
              display="flex"
              flexWrap="nowrap"
              sx={{
                border: '1px solid #eee',
                padding: '0 10px',
              }}
            >
              <AnswerDescriptionBox
                answers={section.questions[questionKey].answersBySamples[0].cumulatedAnswers}
              />
              <div className="flex nowrap basis-100 items-center">
                {
                  section.questions[questionKey].answersBySamples.map(
                    (answersBySamples, caseId) => {
                      const key = `answerChart-${questionKey}-${caseId}`;
                      return (
                        <AnswerChart
                          key={key}
                          submissionerAnswer={answersBySamples.submissionerAnswer}
                          answers={answersBySamples.cumulatedAnswers}
                        />
                      );
                    },
                  )
                }
              </div>
            </Box>
          </div>
          )
        ))
      }
    {sectionJustification
        && (
          <div>
            <h1><FormattedMessage id="trialdetails.sectionReview" /></h1>
            <div>{sectionJustification}</div>
          </div>
        )}
  </div>
);

export default SectionEvaluation;
